const languages = {
  'es_ES': {
    isoCode: 'es_ES', // required!
    empty: '',
    language: 'Idioma',
    ca_ES: 'Catalán',
    es_ES: 'Español',
    en_GB: 'Inglés',
    welcomehombre: 'Bienvenido {name}',
    welcomemujer: 'Bienvenida {name}',
    closeSession: 'Cerrar sesión',
    close: 'cerrar',
    username: 'Usuario',
    password: 'Contraseña',
    forgotUsername: '¿Olvidó su usuario?',
    forgotPassword: '¿Olvidó su contraseña?',
    activeSession: 'Mantenga la sesión activa',
    enter: 'entrar',
    rememberPassword: 'renovar contraseña',
    rememberUser: 'Introduce tu usuario y te enviaremos un email para renovar tu contraseña',
    checkRememberCode: 'Valida el código',
    checkRememberPassword: 'Guardar nueva contraseña',
    newPasword: 'Nueva contraseña',
    repeatPassword: 'Repite la contraseña',
    allRightsReserved: '© CCOO de Catalunya',
    registeredTrademark: 'Sherpa® es una marca registrada de The MountData.',
    privacy: 'Privacidad',
    and: 'y',
    terms: 'Términos',
    secretMonitor: '¿Existe un secreto para controlar todas sus campañas de marketing desde un solo lugar?',
    tellMeMore: '¡Explícame más!',
    results: 'resultados',
    downloadResults: 'Descargar resultados del buscador',
    noResults: 'Sin resultados',
    searcherNotAvailable: 'El buscador no está disponible',
    maxOptions: 'Máximo de {numOptions} opciones',
    select: 'Selecciona',
    selected: '{number} seleccionados',
    deleteSelected: 'borrar seleccionados',
    addSelected: 'añadir seleccionados',
    notSelected: 'no seleccionados',
    enterForSelect: 'Enter para selecc.',
    enterForDelete: 'Enter para borrar',
    filters: 'Seleccionar filtros',
    errorLengthMin: 'mínimo {lengthMin} caracteres',
    errorLengthMax: 'máximo {lengthMax} caracteres',
    errorNumberMin: 'mínimo {lengthMin}',
    errorNumberMax: 'máximo {lengthMax}',
    errorRegExp: 'formato incorrecto{message}',
    errorImgExt: 'tipo de imagen incorrecta{message}',
    errorMandatoryMinOne: 'mínimo {min} respuesta',
    errorMandatoryLanguageMinOne: 'faltan idiomas obligatorios',
    errorMandatoryMin: 'mínimo {min} respuestas',
    errorMandatoryMaxOne: 'máximo {max} respuesta',
    errorMandatoryMax: 'máximo {max} respuestas',
    errorDateFormat: 'Formato de fecha incorrecto{message}',
    errorNumIntervalFormat: 'Intervalo de número incorrecto{message}',
    errorHtmlFormat: 'Formato de html incorrecto{message}',
    save: 'GUARDAR y salir',
    saveAndNew: 'GUARDAR y crear uno nuevo',
    saveAndStay: 'GUARDAR',
    saveContentChanges: 'GUARDAR cambios',
    update: 'GUARDAR y salir',
    updateAndStay: 'GUARDAR',
    andStay: 'y permanecer',
    delete: 'Borrar',
    deleteAll: 'borrar todos',
    deleteHtml: 'Borrar contenido',
    linkClick: 'Haz clic aquí para abrir el enlace',
    linkFileClick: 'Haz clic aquí para abrir el fichero',
    confirmDeleteHtml: '¿Seguro que quieres borrar el contenido?',
    discardChanges: 'Descartar cambios',
    formErrors: 'Revisa los campos del formulario',
    formAddErrors: 'Revisa los campos para agregar el elemento',
    formModifyErrors: 'Revisa los campos para modificar el elemento',
    formSaved: 'Datos guardados correctamente',
    formAddSaved: 'Elemento agregado correctamente',
    formDeleted: 'Datos borrados correctamente',
    formConfirmDelete: '¿Realmente quieres borrar este elemento?',
    yes: 'sí',
    no: 'no',
    add: 'añadir a',
    added: 'añadidos/as',
    addAll: 'añadir todos',
    changeText: 'cambiar texto',
    whoSend: '¿A quien se envía (lista)?',
    uploadHtml: 'Subir HTML',
    subject: 'Asunto',
    examine: 'Examinar',
    scheduleShipping: 'Programar envío',
    template: 'Plantilla',
    saveDraft: 'Guardar borrador',
    saveEmail: 'Guadar email',
    newEmail: 'Crear nuevo email',
    search: 'buscar...',
    searchEmail: 'Buscar email',
    groupFields: 'Campos del grupo',
    searchFields: 'Buscar campos',
    noElements: 'Sin elementos',
    error400: 'Vuelve a iniciar sesión para refrescar tus permisos',
    error401: 'Error en usuario o contraseña',
    error401Remember: 'Error en usuario',
    error403: 'Sin permisos para acceder a este servicio',
    error404: 'Servicio no encontrado',
    error500: 'Error desconocido',
    error412: 'Usuario sin permisos.',
    error408Remember: 'Ya han pasado 10 minutos. Vuelve a solicitar renovar la contraseña',
    error429Remember: 'Sólo tienes 3 intentos. Vuelve a solicitar renovar la contraseña',
    error406Remember: 'El código que has introducido no es válido',
    fileDownloaded: 'Fichero descargado.',
    passwordFormat: 'Define tu nueva contraseña. Al menos 8 caracteres y mínimo: 1 mayúscula, 1 minúscula, 1 número y 1 carácter especial (@#$%^&+!=)',
    passwordSetted: 'Contraseña renovada correctamente',
    incorrectPasswordFormat: 'El formato de la contraseña no es correcto',
    incorrectPasswordRepeat: 'Las dos contraseñas no son iguales',
    rememberSuccess: 'Revisa tu email para introducir el código y renovar la contraseña',
    error500header: 'Error inesperado. Contacta con el administrador del sistema',
    errorLoginEmpty: 'Campos obligatorios',
    errorTaskValidation: 'Completa toda la información para poder ejecutar la tarea.',
    edit: 'Editar',
    visit: 'Visitar',
    see: 'Ver',
    cancel: 'Cancelar',
    cancelChanges: 'CANCELAR cambios',
    infoNewForm: 'Arrastrar los items para construir aquí el formulario',
    addGroup: 'Añadir grupo',
    addSection: 'Añadir Sección',
    saveForm: 'Guardar formulario',
    newForm: 'Crear nuevo formulario',
    searchForms: 'Buscar formularios',
    searchSms: 'Buscar SMS',
    saveSms: 'Guardar SMS',
    newSms: 'Crear nuevo SMS',
    newAds: 'Crear nuevo banner',
    searchAds: 'Campañas display',
    taskError: 'Error en la tarea.',
    remainCharacters: '{count}/{maxLength}',
    of: 'de',
    noImage: 'sin imagen',
    nofile: 'selecciona un archivo',
    saveChanges: '¿Quieres guardar los cambios antes de continuar?',
    saveChangesAfterClose: '¿Deseas guardar los cambios antes de cerrar?',
    continueWithoutSaving: 'Continuar sin guardar',
    id: 'id',
    emojiSelect: 'selecciona emoticono...',
    emojiSearch: 'Buscar',
    emojiNotfound: 'Emoticono no encontrado',
    emojiCategoriesSearch: 'Resultados',
    emojiCategoriesRecent: 'Usados recientemente',
    emojiCategoriesPeople: 'Smileys y Gente',
    emojiCategoriesNature: 'Animales y Naturaleza',
    emojiCategoriesFoods: 'Comida y Bebida',
    emojiCategoriesActivity: 'Actividad',
    emojiCategoriesPlaces: 'Viajes y Sitios',
    emojiCategoriesObjects: 'Objetos',
    emojiCategoriesSymbols: 'Símbolos',
    emojiCategoriesFlags: 'Banderas',
    emojiCategoriesCustom: 'Personalizado',
    translate: 'traducir a los otros idiomas no definidos',
    copyText: 'copiar el texto a los otros idiomas no definidos',
    questions: 'preguntas',
    questionText: 'Texto de la pregunta',
    dictFallbackMessage: 'Tu navegador no soporta la capacidad de arrastrar archivos para subirlos.',
    dictFallbackText: 'Por favor, utiliza el formulario de reserva de abajo para subir tus archivos, como en los viejos tiempos.',
    dictFileTooBig: 'Archivo demasiado grande ({{filesize}}MiB). Tamaño máximo: {{maxFilesize}}MiB.',
    dictInvalidFileType: 'No puedes subir archivos de este tipo.',
    dictResponseError: 'El servidor ha contestado con el código {{statusCode}}.',
    dictCancelUpload: 'Cancelar subida',
    dictCancelUploadConfirmation: '¿Estás seguro de cancelar la subida de archivos?',
    dictRemoveFile: 'Eliminar archivo',
    dictMaxFilesExceeded: 'No puedes subir más archivos.',
    sectionTasks: 'Tareas de Sección',
    addTask: 'Añadir tarea',
    addIndividualParamsTitle: 'Variable Particular',
    addProfessionalParamsTitle: 'Variable Profesional',
    addIndicatorParamsTitle: 'Variable Indicador',
    addMeetingParamsTitle: 'Variable Reunión',
    addMinutesParamsTitle: 'Variable Acta',
    addCertificateParamsTitle: 'Variable Certificado',
    seeTasks: 'Ver tareas',
    nextStep: 'Siguiente paso',
    previousStep: 'Paso previo',
    type: 'Tipo',
    tree: 'Árbol',
    cluster: 'Clúster',
    orientation: 'Orientación',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    circular: 'Circular',
    nodeTextDisplay: 'Visualización del texto',
    all: 'Todo',
    leaves: 'Hojas',
    extremities: 'Extremidades',
    linkLayout: 'Visualización del enlace',
    bezier: 'Bezier',
    orthogonal: 'Ortogonal',
    datepicker: {
      days: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      pickers: ['sig. 7 días', 'sig. 30 días', 'últ. 7 días', 'últ. 30 días'],
      placeholder: {
        date: 'Selecciona fecha',
        dateRange: 'Selecciona rango de fechas',
        duration: 'Tiempo de duración',
        time: 'Tiempo'
      }
    },
    cron: {
      Seconds: {
        name: 'Segundos',
        every: 'Cada segundo',
        interval: ['Cada', 'segundo(s) comenzando en el segundo'],
        specific: 'Segundo específico (escoge uno o varios)',
        cycle: ['Cada segundo entre el segundo', 'y el segundo']
      },
      Minutes: {
        name: 'Minutos',
        every: 'Cada minuto',
        interval: ['Cada', 'minuto(s) comenzando en el minuto'],
        specific: 'Minuto específico (escoge uno o varios)',
        cycle: ['Cada minuto entre el minuto', 'y el minuto']
      },
      Hours: {
        name: 'Horas',
        every: 'Cada hora',
        interval: ['Cada', 'hora(s) comenzando en la hora'],
        specific: 'Hora específica (escoge una o varias)',
        cycle: ['Cada hora entre la hora', 'y la hora']
      },
      Day: {
        name: 'Día',
        every: 'Cada día',
        intervalWeek: ['Cada', 'día(s) comenzando el'],
        intervalDay: ['Cada', 'día(s) comenzando el día', 'del mes'],
        specificWeek: 'Día de la semana específico (escoge uno o varios)',
        specificDay: 'Día del mes específico (escoge uno o varios)',
        lastDay: 'El último día del mes',
        lastWeekday: 'El último día laborable (de Lunes a Viernes) del mes',
        lastWeek: ['El último', ' del mes'],
        beforeEndMonth: ['día(s) antes de final de mes'],
        nearestWeekday: ['El día laborable (de Lunes a Viernes) más cercano al', 'del mes'],
        someWeekday: ['El', 'del mes']
      },
      Week: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      Month: {
        name: 'Mes',
        every: 'Cada mes',
        interval: ['Cada', 'mes(es) comenzando en'],
        specific: 'Mes específico (escoge uno o varios)',
        cycle: ['Cada mes entre', 'y']
      },
      Year: {
        name: 'Año',
        every: 'Cada año',
        interval: ['Cada', 'año(s) comenzando en'],
        specific: 'Año específico (escoge uno o varios)',
        cycle: ['Cada año entre', 'y']
      }
    }
  },
  'ca_ES': {
    isoCode: 'ca_ES', // required!
    empty: '',
    language: 'Idioma',
    ca_ES: 'Català',
    es_ES: 'Espanyol',
    en_GB: 'Anglès',
    welcomehombre: 'Benvingut {name}',
    welcomemujer: 'Benvinguda {name}',
    closeSession: 'Tancar sessió',
    close: 'tancar',
    username: 'Usuari',
    password: 'Contrasenya',
    forgotUsername: 'Ha oblidat l\'usuari?',
    forgotPassword: 'Ha oblidat la contrasenya?',
    activeSession: 'Manteniu la sessió activa',
    enter: 'entrar',
    rememberPassword: 'renovar contrasenya',
    rememberUser: 'Introdueix el teu usuari i t\'enviarem un email per renovar la teva contrasenya',
    checkRememberCode: 'Valida el codi',
    checkRememberPassword: 'Guardar nova contrasenya',
    newPasword: 'Nova contrasenya',
    repeatPassword: 'Repeteix la contrasenya',
    allRightsReserved: '© CCOO de Catalunya',
    registeredTrademark: 'Sherpa® és una marca registrada de The MountData.',
    privacy: 'Privacitat',
    and: 'i',
    terms: 'Termes',
    secretMonitor: 'Existeix un secret per controlar totes les seves campanyes de marketing des de un únic lloc?',
    tellMeMore: 'Explica\'m més!',
    results: 'resultats',
    downloadResults: 'Descarregar resultats del cercador',
    noResults: 'Sense resultats',
    searcherNotAvailable: 'El cercador no està disponible',
    maxOptions: 'Màxim de {numOptions} opcions',
    select: 'Selecciona',
    selected: '{number} seleccionats',
    deleteSelected: 'esborrar seleccionats',
    addSelected: 'afegir seleccionats',
    notSelected: 'no seleccionats',
    enterForSelect: 'Enter per selecc.',
    enterForDelete: 'Enter per esborrar',
    filters: 'Seleccionar filtres',
    errorLengthMin: 'mínim {lengthMin} caràcters',
    errorLengthMax: 'màxim {lengthMax} caràcters',
    errorNumberMin: 'mínim {lengthMin}',
    errorNumberMax: 'màxim {lengthMax}',
    errorRegExp: 'format incorrecte{message}',
    errorImgExt: 'tipus d\'imatge incorrecte{message}',
    errorMandatoryMinOne: 'mínim {min} resposta',
    errorMandatoryLanguageMinOne: 'falten idiomes obligatoris',
    errorMandatoryMin: 'mínim {min} respostes',
    errorMandatoryMaxOne: 'màxim {max} resposta',
    errorMandatoryMax: 'màxim {max} respostes',
    errorDateFormat: 'Format de data incorrecte{message}',
    errorNumIntervalFormat: 'Interval de número incorrecte{message}',
    errorHtmlFormat: 'Format d\'html incorrecte{message}',
    save: 'GUARDAR i sortir',
    saveAndNew: 'GUARDAR i crear un nou',
    saveAndStay: 'GUARDAR',
    saveContentChanges: 'GUARDAR canvis',
    update: 'GUARDAR i sortir',
    updateAndStay: 'GUARDAR',
    andStay: 'i romandre',
    delete: 'Esborrar',
    deleteAll: 'Esborrar tots',
    deleteHtml: 'Esborrar contingut',
    linkClick: 'Fes clic aquí per obrir l\'enllaç',
    linkFileClick: 'Fes clic aquí per obrir el fitxer',
    confirmDeleteHtml: 'Segur que vols esborrar el contingut?',
    discardChanges: 'Descartar canvis',
    formErrors: 'Revisa els camps del formulari',
    formAddErrors: 'Revisa els camps per afegir l\'element',
    formModifyErrors: 'Revisa els camps per modificar l\'element',
    formSaved: 'Dades guardades correctament',
    formAddSaved: 'Element afegit correctament',
    formDeleted: 'Dades esborrades correctament',
    formConfirmDelete: 'Realment vols esborrar aquest element?',
    yes: 'si',
    no: 'no',
    add: 'afegir a',
    added: 'afegits/des',
    addAll: 'afegir tots',
    changeText: 'canviar text',
    whoSend: 'A qui s\'envia (llista)?',
    uploadHtml: 'Pujar HTML',
    subject: 'Assumpte',
    examine: 'Examinar',
    scheduleShipping: 'Programar enviament',
    template: 'Plantilla',
    saveDraft: 'Guardar esborrany',
    saveEmail: 'Guadar email',
    newEmail: 'Crear nou email',
    search: 'cercar...',
    searchEmail: 'Cercar email',
    groupFields: 'Camps del grup',
    searchFields: 'Cercar camps',
    noElements: 'Sense elements',
    error400: 'Torna a iniciar sessió per refrescar els teus permisos',
    error401: 'Error a l\'usuari o contrasenya',
    error401Remember: 'Error a l\'usuari',
    error403: 'Sense permisos per accedir a aquest servei',
    error404: 'Servei no trobat',
    error500: 'Error desconegut',
    error412: 'Usuari sense permisos.',
    error408Remember: 'Ja han passat 10 minuts. Torna a sol·licitar renovar la contrasenya',
    error429Remember: 'Només tens 3 intents. Torna a sol·licitar renovar la contrasenya',
    error406Remember: 'El codi que has introduit no és vàlid',
    fileDownloaded: 'Fitxer descarregat.',
    passwordFormat: 'Defineix la teva nova contrasenya. Com a mínim 8 caràcters i mínim: 1 majúscula, 1 minúscula, 1 número i 1 caràcter especial (@#$%^&+!=)',
    passwordSetted: 'Contrasenya renovada correctament',
    incorrectPasswordFormat: 'El format de la contrasenya no és correcte',
    incorrectPasswordRepeat: 'Les dues contrasenyes no són iguals',
    rememberSuccess: 'Revisa el teu email per introduir el codi i renovar la contrasenya',
    error500header: 'Error inesperat. Contacta amb l\'administrador del sistema',
    errorLoginEmpty: 'Camps obligatoris',
    errorTaskValidation: 'Completa tota la informació per poder executar la tasca.',
    edit: 'Editar',
    visit: 'Visitar',
    see: 'Veure',
    cancel: 'Cancel·lar',
    cancelChanges: 'CANCEL·LAR canvis',
    infoNewForm: 'Arrossegar els items aquí per construir el formulari',
    addGroup: 'Afegir grup',
    addSection: 'Afegir secció',
    saveForm: 'Guardar formulari',
    newForm: 'Crear nou formulari',
    searchForms: 'Cercar formularis',
    searchSms: 'Cercar SMS',
    saveSms: 'Guardar SMS',
    newSms: 'Crear nou SMS',
    newAds: 'Crear nou banner',
    searchAds: 'Campanyes display',
    taskError: 'Error a la tasca.',
    remainCharacters: '{count}/{maxLength}',
    of: 'de',
    noImage: 'sense imatge',
    nofile: 'selecciona un arxiu',
    saveChanges: 'Vols guardar els canvis abans de continuar?',
    saveChangesAfterClose: 'Vols guardar els canvis abans de tancar?',
    continueWithoutSaving: 'Continuar sense guardar',
    id: 'id',
    emojiSelect: 'selecciona emoticona...',
    emojiSearch: 'Cercar',
    emojiNotfound: 'Emoticona no trobada',
    emojiCategoriesSearch: 'Resultats',
    emojiCategoriesRecent: 'Utilitzats recentment',
    emojiCategoriesPeople: 'Smileys i Gent',
    emojiCategoriesNature: 'Animals i Natura',
    emojiCategoriesFoods: 'Menjar i Beguda',
    emojiCategoriesActivity: 'Activitat',
    emojiCategoriesPlaces: 'Viatges i Llocs',
    emojiCategoriesObjects: 'Objectes',
    emojiCategoriesSymbols: 'Símbols',
    emojiCategoriesFlags: 'Banderes',
    emojiCategoriesCustom: 'Personalitzat',
    translate: 'traduir als altres idiomes no definits',
    copyText: 'copiar el text als altres idiomes no definits',
    questions: 'preguntes',
    questionText: 'Text de la pregunta',
    dictFallbackMessage: 'El teu navegador no soporta la capacitat d\'arrossegar arxius per pujar-los.',
    dictFallbackText: 'Si us plau, utiliza el formulari de reserva de sota per pujar els teus arxius, com als vells temps.',
    dictFileTooBig: 'Arxiu massa gran ({{filesize}}MiB). Tamany màxim: {{maxFilesize}}MiB.',
    dictInvalidFileType: 'No pots pujar arxius d\'aquest tipus.',
    dictResponseError: 'El servidor ha contestat amb el codi {{statusCode}}.',
    dictCancelUpload: 'Cancel·lar pujada',
    dictCancelUploadConfirmation: 'Estàs segur de cancel·lar la pujada d\'arxius?',
    dictRemoveFile: 'Eliminar arxiu',
    dictMaxFilesExceeded: 'No pots pujar més arxius.',
    sectionTasks: 'Tasques de Secció',
    addTask: 'Afegir tasca',
    addIndividualParamsTitle: 'Variable Particular',
    addProfessionalParamsTitle: 'Variable Professional',
    addIndicatorParamsTitle: 'Variable Indicador',
    addMeetingParamsTitle: 'Variable Reunió',
    addMinutesParamsTitle: 'Variable Acta',
    addCertificateParamsTitle: 'Variable Certificat',
    seeTasks: 'Veure tasques',
    nextStep: 'Següent pas',
    previousStep: 'Pas previ',
    type: 'Tipus',
    tree: 'Arbre',
    cluster: 'Clúster',
    orientation: 'Orientació',
    vertical: 'Vertical',
    horizontal: 'Horitzontal',
    circular: 'Circular',
    nodeTextDisplay: 'Visualització del text',
    all: 'Tot',
    leaves: 'Fulles',
    extremities: 'Extremitats',
    linkLayout: 'Visualització de l\'enllaç',
    bezier: 'Bezier',
    orthogonal: 'Ortogonal',
    datepicker: {
      days: ['Diu', 'Dil', 'Dmt', 'Dmc', 'Dij', 'Div', 'Dis'],
      months: ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Des'],
      pickers: ['seg. 7 dies', 'seg. 30 dies', 'últ. 7 dies', 'últ. 30 dies'],
      placeholder: {
        date: 'Selecciona data',
        dateRange: 'Selecciona rang de dates',
        duration: 'Temps de durada',
        time: 'Temps'
      }
    },
    cron: {
      Seconds: {
        name: 'Segons',
        every: 'Cada segon',
        interval: ['Cada', 'segon(s) començant al segon'],
        specific: 'Segon específic (escull un o diversos)',
        cycle: ['Cada segon entre el segon', 'i el segon']
      },
      Minutes: {
        name: 'Minuts',
        every: 'Cada minut',
        interval: ['Cada', 'minut(s) començant al minut'],
        specific: 'Minut específic (escull un o diversos)',
        cycle: ['Cada minut entre el minut', 'i el minut']
      },
      Hours: {
        name: 'Hores',
        every: 'Cada hora',
        interval: ['Cada', 'hora(es) començant a l\'hora'],
        specific: 'Hora específica (escull una o diverses)',
        cycle: ['Cada hora entre l\'hora', 'i l\'hora']
      },
      Day: {
        name: 'Dia',
        every: 'Cada dia',
        intervalWeek: ['Cada', 'dia(es) començant el'],
        intervalDay: ['Cada', 'dia(es) començant el dia', 'del mes'],
        specificWeek: 'Dia de la setmana específic (escull un o diversos)',
        specificDay: 'Dia del mes específic (escull un o diversos)',
        lastDay: 'L\'últim dia del mes',
        lastWeekday: 'L\'últim dia laborable (de dilluns a divendres) del mes',
        lastWeek: ['L\'últim', ' del mes'],
        beforeEndMonth: ['dia(es) abans de final de mes'],
        nearestWeekday: ['El dia laborable (de dilluns a divendres) més proper al', 'del mes'],
        someWeekday: ['El', 'del mes']
      },
      Week: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
      Month: {
        name: 'Mes',
        every: 'Cada mes',
        interval: ['Cada', 'mes(os) començant al'],
        specific: 'Mes específic (escull un o diversos)',
        cycle: ['Cada mes entre', 'i']
      },
      Year: {
        name: 'Any',
        every: 'Cada any',
        interval: ['Cada', 'any(s) començant al'],
        specific: 'Any específic (escull un o diversos)',
        cycle: ['Cada any entre', 'i']
      }
    }
  },
  'en_GB': {
    isoCode: 'en_GB', // required!
    empty: '',
    language: 'Language',
    ca_ES: 'Catalan',
    es_ES: 'Spanish',
    en_GB: 'English',
    welcomehombre: 'Welcome {name}',
    welcomemujer: 'Welcome {name}',
    closeSession: 'Close session',
    close: 'close',
    username: 'Username',
    password: 'Password',
    forgotUsername: 'Forgot username?',
    forgotPassword: 'Forgot password?',
    activeSession: 'Keep the session active',
    enter: 'enter',
    rememberPassword: 'renew password',
    rememberUser: 'Enter your username and we will send you an email to renew your password',
    checkRememberCode: 'Validate the code',
    checkRememberPassword: 'Save new password',
    newPasword: 'New password',
    repeatPassword: 'Repeat password',
    allRightsReserved: '© CCOO de Catalunya',
    registeredTrademark: 'Sherpa® is a registered trademark of The MountData.',
    privacy: 'Privacy',
    and: 'and',
    terms: 'Terms',
    secretMonitor: 'Is there a secret to monitor all your marketing campaigns from a single place?',
    tellMeMore: 'Tell me more!',
    results: 'results',
    downloadResults: 'Download searcher results',
    noResults: 'No results',
    searcherNotAvailable: 'The searcher is not available',
    maxOptions: 'Maximum of {numOptions} options',
    select: 'Select',
    selected: '{number} selected',
    deleteSelected: 'delete selected',
    addSelected: 'add selected',
    notSelected: 'not selected',
    enterForSelect: 'Enter for select',
    enterForDelete: 'Enter for delete',
    filters: 'Select filters',
    errorLengthMin: '{lengthMin} chars min',
    errorLengthMax: '{lengthMax} chars max',
    errorNumberMin: '{lengthMin} min',
    errorNumberMax: '{lengthMax} max',
    errorRegExp: 'wrong format{message}',
    errorImgExt: 'wrong image type{message}',
    errorMandatoryMinOne: '{min} answer min',
    errorMandatoryLanguageMinOne: 'missing required languages',
    errorMandatoryMin: '{min} answers min',
    errorMandatoryMaxOne: '{max} answer max',
    errorMandatoryMax: '{max} answers max',
    errorDateFormat: 'Incorrect date format{message}',
    errorNumIntervalFormat: 'Incorrect number range{message}',
    errorHtmlFormat: 'Incorrect html format{message}',
    save: 'SAVE and exit',
    saveAndNew: 'SAVE and create a new one',
    saveAndStay: 'SAVE',
    saveContentChanges: 'SAVE changes',
    update: 'UPDATE and exit',
    updateAndStay: 'UPDATE',
    andStay: 'and stay',
    delete: 'Delete',
    deleteAll: 'delete all',
    deleteHtml: 'Delete content',
    linkClick: 'Click here to open the link',
    linkFileClick: 'Click here to open the file',
    confirmDeleteHtml: 'Are you sure you want to delete this content?',
    discardChanges: 'Discard changes',
    formErrors: 'Check form fields',
    formAddErrors: 'Check the fields to add the element',
    formModifyErrors: 'Check the fields to modify the element',
    formSaved: 'Saved data correctly',
    formAddSaved: 'Element added correctly',
    formDeleted: 'Deleted data correctly',
    formConfirmDelete: 'Do you really want to delete this element?',
    yes: 'yes',
    no: 'no',
    add: 'add to',
    added: 'added',
    addAll: 'add all',
    changeText: 'change text',
    whoSend: 'To whom is it sent (list)?',
    uploadHtml: 'Upload HTML',
    subject: 'Subject',
    examine: 'Examine',
    scheduleShipping: 'Schedule shipping',
    template: 'Template',
    saveDraft: 'Save draft',
    saveEmail: 'Save email',
    newEmail: 'New email',
    search: 'search...',
    searchEmail: 'Search email',
    groupFields: 'Group fields',
    searchFields: 'Search fields',
    noElements: 'No elements',
    error400: 'Log back in to refresh your permissions',
    error401: 'Error in user or password',
    error401Remember: 'Error in user',
    error403: 'No permission to access this service',
    error404: 'Service not found',
    error500: 'Error unknown',
    error412: 'User without rights.',
    error408Remember: 'It\'s been 10 minutes. Please request a password reset',
    error429Remember: 'You only have 3 attempts. Please request a password reset',
    error406Remember: 'The code you entered is invalid',
    fileDownloaded: 'File downloaded.',
    passwordFormat: 'Define your new password. At least 8 characters and minimum: 1 uppercase, 1 lowercase, 1 number and 1 special character (@#$%^&+!=)',
    passwordSetted: 'Password renewed successfully',
    incorrectPasswordFormat: 'The password format is incorrect',
    incorrectPasswordRepeat: 'The two passwords aren\'t equals',
    rememberSuccess: 'Check your email to introduce the code and renew the password',
    error500header: 'Unexpected error. Contact with the system administrator',
    errorLoginEmpty: 'Required fields',
    errorTaskValidation: 'Complete all the information to be able to execute the task.',
    edit: 'Edit',
    visit: 'Visit',
    see: 'See',
    cancel: 'Cancel',
    cancelChanges: 'CANCEL changes',
    infoNewForm: 'Drag the items to build the form here',
    addGroup: 'Add group',
    addSection: 'Add Section',
    saveForm: 'Save form',
    newForm: 'New form',
    searchForms: 'Search forms',
    searchSms: 'Search SMS',
    saveSms: 'Save SMS',
    newSms: 'New SMS',
    newAds: 'New banner',
    searchAds: 'Campaigns display',
    taskError: 'Task error.',
    remainCharacters: '{count}/{maxLength}',
    of: 'of',
    noImage: 'No image',
    nofile: 'select a file',
    saveChanges: 'Do you want to save the changes before continuing?',
    saveChangesAfterClose: 'Do you want to save the changes before closing?',
    continueWithoutSaving: 'Continue without saving',
    id: 'id',
    emojiSelect: 'pick emoji...',
    emojiSearch: 'Search',
    emojiNotfound: 'No Emoji Found',
    emojiCategoriesSearch: 'Search Results',
    emojiCategoriesRecent: 'Frequently Used',
    emojiCategoriesPeople: 'Smileys & People',
    emojiCategoriesNature: 'Animals & Nature',
    emojiCategoriesFoods: 'Food & Drink',
    emojiCategoriesActivity: 'Activity',
    emojiCategoriesPlaces: 'Travel & Places',
    emojiCategoriesObjects: 'Objects',
    emojiCategoriesSymbols: 'Symbols',
    emojiCategoriesFlags: 'Flags',
    emojiCategoriesCustom: 'Custom',
    translate: 'translate to other languages ​​not defined',
    copyText: 'copy text to other languages ​​not defined',
    questions: 'questions',
    questionText: 'Question text',
    dictFallbackMessage: 'Your browser does not support the ability to drag files to upload them.',
    dictFallbackText: 'Please use the booking form below to upload your files, as in the old days.',
    dictFileTooBig: 'File too big ({{filesize}}MiB). Maximum size: {{maxFilesize}}MiB.',
    dictInvalidFileType: 'You can not upload files of this type.',
    dictResponseError: 'The server has answered with the code {{statusCode}}.',
    dictCancelUpload: 'Cancel upload',
    dictCancelUploadConfirmation: 'Are you sure to cancel the file upload?',
    dictRemoveFile: 'Delete file',
    dictMaxFilesExceeded: 'You can not upload more files.',
    sectionTasks: 'Section Tasks',
    addTask: 'Add task',
    addIndividualParamsTitle: 'Particular Variable',
    addProfessionalParamsTitle: 'Professional Variable',
    addIndicatorParamsTitle: 'Indicator Variable',
    addMeetingParamsTitle: 'Meeting Variable',
    addMinutesParamsTitle: 'Minutes Variable',
    addCertificateParamsTitle: 'Certificate Variable',
    seeTasks: 'See tasks',
    nextStep: 'Next step',
    previousStep: 'Previous step',
    type: 'Type',
    tree: 'Tree',
    cluster: 'Cluster',
    orientation: 'Orientation',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    circular: 'Circular',
    nodeTextDisplay: 'Text display',
    all: 'All',
    leaves: 'Leaves',
    extremities: 'Extremities',
    linkLayout: 'Link layout',
    bezier: 'Bezier',
    orthogonal: 'Orthogonal',
    datepicker: {
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
      placeholder: {
        date: 'Select date',
        dateRange: 'Select date range',
        duration: 'Duration time',
        time: 'Time'
      }
    },
    cron: {
      Seconds: {
        name: 'Seconds',
        every: 'Every second',
        interval: ['Every', 'second(s) starting at second'],
        specific: 'Specific second (choose one or many)',
        cycle: ['Every second between second', 'and second']
      },
      Minutes: {
        name: 'Minutes',
        every: 'Every minute',
        interval: ['Every', 'minute(s) starting at minute'],
        specific: 'Specific minute (choose one or many)',
        cycle: ['Every minute between minute', 'and minute']
      },
      Hours: {
        name: 'Hours',
        every: 'Every hour',
        interval: ['Every', 'hour(s) starting at hour'],
        specific: 'Specific hour (choose one or many)',
        cycle: ['Every hour between hour', 'and hour']
      },
      Day: {
        name: 'Day',
        every: 'Every day',
        intervalWeek: ['Every', 'day(s) starting on'],
        intervalDay: ['Every', 'day(s) starting at the', 'of the month'],
        specificWeek: 'Specific day of week (choose one or many)',
        specificDay: 'Specific day of month (choose one or many)',
        lastDay: 'On the last day of the month',
        lastWeekday: 'On the last weekday of the month',
        lastWeek: ['On the last', ' of the month'],
        beforeEndMonth: ['day(s) before the end of the month'],
        nearestWeekday: ['Nearest weekday (Monday to Friday) to the', 'of the month'],
        someWeekday: ['On the', 'of the month']
      },
      Week: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      Month: {
        name: 'Month',
        every: 'Every month',
        interval: ['Every', 'month(s) starting in'],
        specific: 'Specific month (choose one or many)',
        cycle: ['Every month between', 'and']
      },
      Year: {
        name: 'Year',
        every: 'Any year',
        interval: ['Every', 'year(s) starting in'],
        specific: 'Specific year (choose one or many)',
        cycle: ['Every year between', 'and']
      }
    }
  }
}

export default languages



// WEBPACK FOOTER //
// ./src/language/languages.js